var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-items-center justify-content-center placeholder"},[_c('label',[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])]),_c('div',{staticClass:"d-flex align-items-center justify-content-center placeholder"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","size":_vm.size,"pulse":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }